<main>
  <header><img src="/assets/images/logo.png" alt="Rensa academy logo" routerLink="/" /></header>
  <router-outlet></router-outlet>
</main>
